<div class="h-full flex flex-col">
  <header class="">
    <app-toolbar
      [showMenu]="false"
      [addExtraSpacing]="false"
      [showHomeNavigationRoutes]="false"
    ></app-toolbar>
  </header>
  <div class="grow h-full overflow-x-hidden overflow-y-auto">
    <router-outlet></router-outlet>
  </div>
  <footer class="bg-gray-100 py-6 text-center text-sm text-gray-500">
    &copy; 2025 Aimi. All rights reserved.
  </footer>
</div>
